import apiClient from '../utils/apiClient';

export const getMyProfile = () => apiClient.get('/profile/me').then(r => r.data);
export const updateMyProfile = (fields) => apiClient.put('/profile/me', fields).then(r => r.data);

const section = (name) => ({
  add: (data) => apiClient.post(`/profile/me/${name}`, data).then(r => r.data),
  update: (id, data) => apiClient.put(`/profile/me/${name}/${id}`, data).then(r => r.data),
  remove: (id) => apiClient.delete(`/profile/me/${name}/${id}`).then(r => r.data),
});

export const experienceApi = section('experience');
export const educationApi = section('education');
export const skillsApi = section('skills');
export const languagesApi = section('languages');
export const certificationsApi = section('certifications');

export const uploadResume = (file) => {
  const form = new FormData();
  form.append('file', file);
  return apiClient
    .post('/profile/me/resume', form, { headers: { 'Content-Type': 'multipart/form-data' } })
    .then(r => r.data);
};

export const deleteResume = () => apiClient.delete('/profile/me/resume').then(r => r.data);

export const downloadResume = (filename) =>
  apiClient.get('/profile/me/resume/download', { responseType: 'blob' }).then(res => {
    const url = window.URL.createObjectURL(new Blob([res.data]));
    const a = document.createElement('a');
    a.href = url;
    a.download = filename || 'resume.pdf';
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
  });
